import { createElement } from 'react';
import { svgIconClasses } from '@mui/material';
import EmptyStar from 'src/components/icons/EmptyStar';
import Star from 'src/components/icons/Star';
const MuiRating = {
  defaultProps: {
    icon: /*#__PURE__*/createElement(Star),
    emptyIcon: /*#__PURE__*/createElement(EmptyStar)
  },
  styleOverrides: {
    root: ({
      theme,
      ownerState
    }) => ({
      [`& .${svgIconClasses.root}`]: {
        ...(ownerState.size === 'small' && {
          width: theme.spacing(2),
          height: theme.spacing(2)
        }),
        ...(ownerState.size === 'medium' && {
          width: theme.spacing(3),
          height: theme.spacing(3)
        }),
        ...(ownerState.size === 'large' && {
          width: theme.spacing(4),
          height: theme.spacing(4)
        })
      }
    }),
    icon: ({
      theme
    }) => ({
      color: theme.palette.common.white
    })
  }
};
export default MuiRating;